var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us"},[_c('v-banner-box',{attrs:{"data":_vm.swiperData}},[_c('template',{slot:"button"},[_c('p')])],2),_c('v-contact-us'),_c('v-recruitment')],1)}
var staticRenderFns = []

export { render, staticRenderFns }